import React from 'react'
import HeroBlock from '../blocks/HeroBlock'
import SocialShareBlock from '../blocks/SocialShareBlock'
import Layout from '../modules/Layout'
import BodyBlocks from '../technical/BodyBlocks'
import SEO from '../modules/Seo'

import * as moment from 'moment'

const ArticlePage = ({ content, name, locale, alternates }) => {
  moment.locale(locale)
  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} name={name} og_locale={locale} />

        <HeroBlock
          block={{
            hero_mirrored: content.hero_mirrored,
            date:
              content.date?.length > 0
                ? moment(content.date).format('MMMM YYYY')
                : '',
            kicker: name,
            headline: content.headline?.length > 0 ? content.headline : name,
            image: content.header_image,
          }}
        />
        <SocialShareBlock />
        <BodyBlocks body={content.body} />
      </Layout>
    </div>
  )
}

export default ArticlePage
